import SegmentRule from '@/engine/rules/segment-rule'
import GameState from '@/engine/models/game-state'
import TurnState from '@/engine/models/turn-state'
import Segment from '@/engine/models/segment'
import States from '@/engine/common/states'
import audioService from '@/services/audio-service'

export default class PayRentRule extends SegmentRule {

    protected segmentSatisfied(turnState: TurnState, state: GameState, segment: Segment): boolean {
        return state.gameplay.enabledConquerAll === false
            && segment.id !== 'b00'
            && segment.id !== 'e00'
            && segment.owner !== null
    }

    protected segmentAction(turnState: TurnState, state: GameState, segment: Segment): GameState {
        // Gäste zahlen immer drauf.
        if (segment.owner != null && segment.owner.id !== state.team.id) {
            States.pay(state, segment)
            this.playAudio(turnState)
        } else if (state.gameplay.enabledFriendlyFire) {
            switch (segment.alph) {
                case 'd':
                    if (segment.houses >= state.gameplay.maxHouses) {
                        States.pay(state, segment)
                        this.playAudio(turnState)
                    }
                    break
                case 't':
                    if (segment.houses < state.gameplay.maxHouses) {
                        States.pay(state, segment)
                        this.playAudio(turnState)
                    } else if (segment.villas >= state.gameplay.maxVillas) {
                        States.pay(state, segment)
                        this.playAudio(turnState)
                    }
                    break
                default:
                    States.pay(state, segment)
                    this.playAudio(turnState)
                    break
            }
        }
        return state
    }

    private playAudio(turnState: TurnState) {
        if (turnState.turnComplete === false) {
            audioService.playPayRent()
        }
    }
}
